module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921091149_T.4bd2d095.jpg";